import { render, staticRenderFns } from "./EmployeesReports.vue?vue&type=template&id=0bcfe73c&scoped=true&"
import script from "./EmployeesReports.vue?vue&type=script&lang=js&"
export * from "./EmployeesReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcfe73c",
  null
  
)

export default component.exports